/**
 * StatementActions — Batch #14.320 : livrer un état financier au client comme les rapports DAS.
 * Courriel (PDF, mot de passe optionnel) · Drive (dossier Entrepreneur par défaut) · dernier envoi / classement pour la période affichée.
 * Tenue de livres seulement (la portée cabinet n'a pas de client destinataire).
 */
import { useCallback, useEffect, useState } from "react";
import { Mail } from "lucide-react";
import { api } from "@/api";
import DriveSendButton from "@/components/admin/DriveSendButton";
import { Btn, useGlBase } from "../_shared";
import StatementEmailDialog from "./StatementEmailDialog";

const STATEMENT_KINDS = ["income-statement", "balance-sheet", "financial-statements"];
const fmt = (iso) => (iso ? iso.slice(0, 16).replace("T", " ") : "");

export default function StatementActions({ kind, query, ready }) {
  const base = useGlBase();
  const masterId = base.startsWith("/books/") ? base.slice(7) : null;
  const [status, setStatus] = useState(null);
  const [open, setOpen] = useState(false);
  const q = Object.fromEntries(Object.entries(query).filter(([, v]) => v));

  const load = useCallback(() => {
    if (!masterId || !STATEMENT_KINDS.includes(kind) || !ready) return;
    api.get(`${base}/reports/${kind}/status`, { params: q }).then((r) => setStatus(r.data)).catch(() => setStatus(null));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [base, kind, masterId, ready, JSON.stringify(q)]);
  useEffect(() => { load(); }, [load]);

  if (!masterId || !STATEMENT_KINDS.includes(kind)) return null;
  const docId = `${masterId}:${kind}:${kind === "income-statement" ? `${q.date_from}:${q.date_to}` : q.as_of}`;
  const lastMail = status?.sent_log?.slice(-1)[0];
  const lastDrive = status?.drive_uploads?.slice(-1)[0];
  return (
    <div className="flex items-center gap-2 flex-wrap" data-testid="statement-actions">
      {(lastMail || lastDrive) && (
        <span className="text-[11px] text-slate-500 flex items-center gap-2 flex-wrap" data-testid="statement-status">
          {lastMail && <span data-testid="statement-last-email">Courriel : {fmt(lastMail.at)} → {lastMail.to}{lastMail.ok === false && <span className="text-rose-600"> (échec)</span>}</span>}
          {lastDrive && <span data-testid="statement-last-drive">Drive : {fmt(lastDrive.at)}{lastDrive.web_link && <> — <a href={lastDrive.web_link} target="_blank" rel="noreferrer" className="underline" data-testid="statement-drive-link">ouvrir</a></>}</span>}
        </span>
      )}
      <Btn tone="sky" icon={Mail} disabled={!ready} onClick={() => setOpen(true)} testId="statement-email-btn">Courriel</Btn>
      <DriveSendButton docType="books_report" docId={docId} defaultExpertise="entrepreneur" title="Classer cet état financier dans Google Drive" onSent={load} />
      {open && <StatementEmailDialog kind={kind} query={q} defaultTo={status?.default_to || ""} period={status?.period} onClose={() => setOpen(false)} onSent={load} />}
    </div>
  );
}
